import React, {Component} from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {getFilterEventsSearch} from '../../actions/eventsActions';
import {Row, Col} from 'reactstrap';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import config from "../../utils/config.json";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import Select from 'react-select';

class EventsSearch extends Component {
  constructor(props) {
        super(props);
        this.state = {
            idEvents : null,
            startDate: null,
            endDate: null,
            placeholder: 'Sélectionnez une période',
            selectedOption: null,
            options: [],
        };
    }


  loadOptions = inputValue => {
    fetch(`${config.apiUrl}/events?display=[id,title]&ws_key=${config.apiKey}&${config.dataType}`)
    
      .then(response => response.json())
      .then(data => {
        const options = data.eventss.map(item => ({
          value: item.id,
          label: item.title,
        }));
        this.setState({ options });
      })
      .catch(error => {
        console.error('Erreur lors du chargement des options', error);
        this.setState({ options: [] });
      });
  };

  handleSelectChange = selectedOption => {
    this.setState({ selectedOption });
  };


    change = e =>{
          this.setState({
              [e.target.id] : e.target.value
          }); 
    };
    handleDateRangeApply = (e, picker) => {
      e.preventDefault();
      const startDate = picker.startDate.format('YYYY-MM-DD');
      const endDate = picker.endDate.format('YYYY-MM-DD');
      
      this.setState({ startDate, endDate });
    };

  componentDidMount() {
    
  }

   submit = e =>{
          e.preventDefault();
          let {getFilterEventsSearch} = this.props
          const formData = {
              idEvents : this.state.selectedOption.value,
              startDate: this.state.startDate,
              endDate: this.state.endDate,
          };
          getFilterEventsSearch(formData)
          console.log(formData)
    }

  render() {
    
    const { selectedOption, options } = this.state;

    return (
      <div>
        <form onSubmit={this.submit} id="form-search">
            <Row>
              <Col  md="6" lg="5" className="columns-search">
                   <Select
                      isSearchable
                      isClearable
                      placeholder="Mots clés ..."
                      value={selectedOption}
                      onChange={this.handleSelectChange}
                      onInputChange={this.loadOptions} // Utilisez onInputChange pour déclencher la recherche
                      options={options}
                    />
              </Col>
              <Col  md="2" lg="4" className="colums-date">
                <DateRangePicker
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  onApply={this.handleDateRangeApply}
                >
                  <input type="text" 
                  className="form-control periode"
                   value={this.state.startDate && this.state.endDate ? this.state.startDate + ' à ' + this.state.endDate : this.state.placeholder}
                   required />
                </DateRangePicker>
                <i className="fas fa-calendar"></i>
              </Col>
              <Col  md="2" lg="2">
                <input type="submit" className="btn btn-primary"value="Recherche"/>
              </Col>
            </Row>
          </form>
      </div>
    )
  }
}


function mapStateToProps({eventsReducer}) {
  return {
    events: eventsReducer
  }
}

function mapDispatchToProps(dispatch) {
  return {
    getFilterEventsSearch: bindActionCreators(getFilterEventsSearch, dispatch),
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(EventsSearch);


// WEBPACK FOOTER //
// ./src/components/events/EventsSearch.js